import * as React from "react";
import "./dataGrid.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Indicates if component has hoverable rows.
	 */
	hasHover?: boolean;
	/**
	 * Indicates if cursor is set to pointer.
	 */
	hasPointer?: boolean;
}

export default class DataGrid extends React.Component<IProps, {}> {
	render() {

		const classFromProps = classNames({
			"has-hover" : Boolean(this.props.hasHover),
			"has-pointer" : Boolean(this.props.hasPointer),
			"o-data-grid": true,

		});

		return (
			<table className={classFromProps}>
				{this.props.children}
			</table>
		);
	}
}
